<template>
  <c-view>
    <c-page>
      <c-navbar></c-navbar>
      <c-content>
        <c-swipe v-square :images="banners" :auto="0"></c-swipe>
        <c-panel-container>
          <c-panel :title="goodsInfo.title" :desc="goodsInfo.desc">
            <div class="price">{{ goodsInfo.price | currency0}}</div>
          </c-panel>
        </c-panel-container>
        <c-tab :tabItems="tabItems" @itemClick="tabTtemClickHandler"></c-tab>
        <template v-if="currentTab==tabItems[0].tabName">
          <c-images :imgItems="goodsDetailImgs"></c-images>
        </template>
        <template v-if="currentTab==tabItems[1].tabName">
          <div class="goods-text-info" v-html="goodsDetailText"></div>
        </template>
      </c-content>
      <c-footer>
        <c-button @click.native="buy">
          <div>立即购买</div>
        </c-button>
      </c-footer>
    </c-page>
    <!--数量选择器-->
    <div>
      <div v-view-fixed class="weui-mask" @click="closeMask" :class="[buying ? 'mask-show' : 'mask-hide',maskRealHide ? 'mask-real-hide':'']"></div>
      <div class="weui-actionsheet" :class="[buying ? 'weui-actionsheet_toggle':'']">
        <div class="choose-count">
          <div class="title">数量</div>
          <c-counter v-model="selectCount" :minValue="1"></c-counter>
        </div>
        <div class="total">
          <div class="title">总价</div>
          <div>{{ selectCount * goodsInfo.price | currency0}}</div>
        </div>
        <c-button @click.native="orderConfirm">提交</c-button>
      </div>
    </div>
    <transition name="slide-right" mode="out-in">
      <router-view></router-view>
    </transition>
  </c-view>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  import Hardware from '../../../model/hardware-market'
  import StdGoodsEntity from '../../../model/std-goods-entity'
  import Tickets from '../../../model/tickets'
  import debounce from 'lodash.debounce'

  export default {
    data () {
      return {
        goodsId: 0,
        hardware: new Hardware(),
        banners: [],
        goodsInfo: {},
        goodsDetailImgs: [],
        goodsDetailText: '',
        currentTab: 'goodsImgDetail',
        tabItems: [{
          name: '商品详情',
          select: true,
          tabName: 'goodsImgDetail'
        }, {
          name: '规格参数',
          select: false,
          tabName: 'goods'
        }],
        selectCount: 1,
        buying: false,
        maskRealHide: true
      }
    },
    components: {},
    created () {
      this.goodsId = this.$route.params.id
      this.hardware.loadDetail(this.goodsId).then(res => {
        let data = res
        let goodsInfo = data.goodsInfo
        this.banners = data.banners
        this.goodsInfo = goodsInfo
        this.goodsDetailImgs = goodsInfo.detailImages
        this.goodsDetailText = goodsInfo.detailText
      }).catch(e => {
      })
      this.init()
    },
    mounted () {
    },
    beforeDestroy () {
    },
    methods: {
      init () {
        // 重置订单确认页的config
        this.$store.commit('resetOrderConfirmConfig')
        // 清理其他业务设置的优惠券，或设置自己的优惠券
        this.$store.commit('cleanOrderTicket')
      },
      tabTtemClickHandler (itemObj) {
        this.currentTab = itemObj.tabName
        for (let item of this.tabItems) {
          item.select = item === itemObj
        }
      },
      closeMask () {
        this.buying = false
        setTimeout(() => {
          this.maskRealHide = true
        }, 220)
      },
      buy: debounce(function () {
        this.buying = true
        this.maskRealHide = false
        this.selectCount = 1
      }, 220),
      orderConfirm: debounce(async function () {
        this.closeMask()
        let goodsInfoObj = await StdGoodsEntity.goodsInfo({
          goodsId: this.goodsId,
          goodsType: StdGoodsEntity.HARDWARE_TYPE,
          quantity: this.selectCount
        })
        let oriCouponList = StdGoodsEntity.CouponListModels(goodsInfoObj)
        Tickets.SetTicket(Tickets.ConvertCouponListModels(oriCouponList))
        let integral = StdGoodsEntity.IntegralModels(goodsInfoObj)
        // 存储当前物品信息和数量
        this.$store.commit('setOrderGoodsInfo', {
          goodsId: this.goodsId,
          name: this.goodsInfo.title,
          icon: this.goodsInfo.icon,
          price: this.goodsInfo.price,
          count: this.selectCount,
          isCouponUnAvaliable: !oriCouponList.length > 0,
          isIntegralUnAvaliable: !integral > 0,
          goodsType: StdGoodsEntity.HARDWARE_TYPE
        })
        this.$router.push({path: `${this.$route.path}/orderConfirm`})
      }, 220)
    },
    computed: {},
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?33096489